import { render, staticRenderFns } from "./DiscountRules.vue?vue&type=template&id=6145fbd4&"
import script from "./DiscountRules.vue?vue&type=script&lang=ts&"
export * from "./DiscountRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports